import { useEffect, useState } from "react";
import MixedChart2LinesBarMarker from "./MixedChart2LinesBarMarker";
import MixedChart0LinesBarMarker from "./MixedChart0LinesBarMarker";
import ProgressBar from "./Progressbar";
import MixedChart2LinesBarMarkerComponent from "./MixedChart2LinesBarMarkerComponent";

export default function MixedChart(props){
    //console.log("IN MixedChart I AM IN");
    const [charttype, setChartType] = useState('');

    useEffect(()=>{
        //console.log("INSIDE MIXED CHART USEEFFECT START")
        const chart_map = new Map();
        chart_map.set('bar', 0);
        chart_map.set('line', 0);
        chart_map.set('area', 0);
        chart_map.set('marker', 0);

        var tag_properties =props.widgetprop.props.extended.tagprops;
        //console.log("tag_properties",tag_properties)

        tag_properties.map((charttype)=>
            {
                var count;
                if(charttype.charttype == 'line'){
                    count = chart_map.get('line')
                    chart_map.set('line',count + 1);
                    //console.log("after line ",chart_map);
                }else if(charttype.charttype == 'bar'){
                    count = chart_map.get('bar')
                    chart_map.set('bar',count + 1);
                    //console.log("after bar ",chart_map);
                }else if(charttype.charttype == 'area'){
                    count = chart_map.get('area')
                    chart_map.set('area',count + 1);
                    //console.log("after area ",chart_map);
                }else if(charttype.charttype == 'marker'){
                    count = chart_map.get('marker')
                    chart_map.set('marker',count + 1);
                    //console.log("after marker ",chart_map);
                }
                count = 0; 
            }
        )

        var chartsubtype = chart_map.get('line')+'line_'+chart_map.get('bar')+'bar_'+chart_map.get('area')+'area_';
        console.log("mix chartsubtype",chartsubtype);

        switch(chartsubtype){
            case "1line_1bar_0area_":
                console.log("2line_1bar_0area_---------",chartsubtype)
                setChartType("MixedChart2LinesBarMarker")
                break
            case "2line_1bar_0area_":
                console.log("2line_1bar_0area_---------",chartsubtype)
                setChartType("MixedChart2LinesBarMarker")
                break
            case "3line_1bar_0area_":
                console.log("2line_1bar_0area_---------",chartsubtype)
                setChartType("MixedChart2LinesBarMarker")
                break
            case "0line_1bar_0area_":
                //console.log("props.widgetprop.type MixedChart0LinesBarMarker",props.widgetprop.type)
                // setChartType("MixedChart0LinesBarMarker")
                setChartType("MixedChart2LinesBarMarker")
                break
        }

    },[])

    return(
        <>
            {(props.widgetprop.type=="progressbar_mix") && <ProgressBar widgetprop={props.widgetprop}/>}
            {(charttype === 'MixedChart2LinesBarMarker' && (props.widgetprop.type !=="progressbar_mix")) ? <MixedChart2LinesBarMarker widgetprop={props.widgetprop}/>:<MixedChart2LinesBarMarkerComponent widgetprop={props.widgetprop}/>}
            
        </>
    )
}